import { RouteType } from "types/RouteType";
import OrdersListStore from "./OrdersList.Store";

const OrdersListRoute: RouteType = {
  name: "Orders List",
  path: "/orders",
  layout: "/app",
  group: "Orders",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Orders",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./OrdersList.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    // Initialize store if not exists
    if (!rootStore.ordersListStore) {
      rootStore.ordersListStore = new OrdersListStore(rootStore);
    }
    // Reset to clean state when entering
    const store = rootStore.ordersListStore as OrdersListStore;
    store.reset();
    return true;
  },
};

export default OrdersListRoute;
